import React from 'react'
import styles from './PageShell.module.scss'

const PageShell = ({ children, className = '' }) => (
  <div
    className={`${styles.root} msr-ui ${className}`.trim()}
    data-msr-ui='v2'
    data-msr-page-shell='true'
  >
    {children}
  </div>
)

export default PageShell
